import { Directive } from '@angular/core';

/** Directive that should be applied to the text element to be rendered in the snack bar. */
@Directive({
  selector: `[ndtSnackBarLabel]`,
  host: {
    class: 'ndt-mdc-snack-bar-label mdc-snackbar__label',
  },
})
export class NdtSnackBarLabel {}

/** Directive that should be applied to the element containing the snack bar's action buttons. */
@Directive({
  selector: `[ndtSnackBarActions]`,
  host: {
    class: 'ndt-mdc-snack-bar-actions mdc-snackbar__actions',
  },
})
export class NdtSnackBarActions {}

/** Directive that should be applied to each of the snack bar's action buttons. */
@Directive({
  selector: `[ndtSnackBarAction]`,
  host: {
    class: 'ndt-mdc-snack-bar-action mdc-snackbar__action',
  },
})
export class NdtSnackBarAction {}
